var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessages(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/Messages"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 4.375C8.68426 4.375 4.375 8.68426 4.375 14C4.375 15.2389 4.60865 16.4212 5.03349 17.5066C5.25354 18.0688 5.362 18.7124 5.25123 19.3701L4.56701 23.433L8.62988 22.7488C9.28761 22.638 9.93115 22.7465 10.4934 22.9665C11.5788 23.3914 12.7611 23.625 14 23.625C19.3157 23.625 23.625 19.3157 23.625 14C23.625 8.68426 19.3157 4.375 14 4.375ZM2.625 14C2.625 7.71776 7.71776 2.625 14 2.625C20.2822 2.625 25.375 7.71776 25.375 14C25.375 20.2822 20.2822 25.375 14 25.375C12.5393 25.375 11.1409 25.0992 9.85553 24.5961C9.52672 24.4674 9.20634 24.4263 8.92051 24.4745L4.45353 25.2267C3.46472 25.3933 2.60674 24.5353 2.77326 23.5465L3.52553 19.0795C3.57367 18.7937 3.53256 18.4733 3.40387 18.1445C2.90076 16.8591 2.625 15.4607 2.625 14Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon (Stroke)_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.45831 11.6664C8.45831 11.1831 8.85006 10.7914 9.33331 10.7914H18.6666C19.1499 10.7914 19.5416 11.1831 19.5416 11.6664C19.5416 12.1496 19.1499 12.5414 18.6666 12.5414H9.33331C8.85006 12.5414 8.45831 12.1496 8.45831 11.6664ZM8.45831 16.333C8.45831 15.8498 8.85006 15.458 9.33331 15.458H14C14.4832 15.458 14.875 15.8498 14.875 16.333C14.875 16.8163 14.4832 17.208 14 17.208H9.33331C8.85006 17.208 8.45831 16.8163 8.45831 16.333Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessages);
export default __webpack_public_path__ + "static/media/Messages.7eed6544a9f18c3204f5ad7e16a91d0a.svg";
export { ForwardRef as ReactComponent };